import { z } from 'zod';
import { EnumUtils } from '@colonist/utils';
import { createKeyRecordSchema } from '../KeyRecordSchemas.ts';
import { createPartialStrictObjectSchemaWithAtLeastOneProperty } from '../PartialStrictObjectSchema.ts';
import { validateState } from '../ValidateState.ts';
import { CityImprovementTypes } from './MechanicCityImprovements.ts';
import { PlayerColor } from '../PlayerState.ts';
const cityImprovementTypeKeys = EnumUtils.getEnumValues(CityImprovementTypes);
const MIN_CITY_IMPROVEMENT_LEVEL = 0;
const MAX_CITY_IMPROVEMENT_LEVEL = 5;
const mechanicCityImprovementsTypeStateSchema = z.object({
    level: z.number().int().min(MIN_CITY_IMPROVEMENT_LEVEL).max(MAX_CITY_IMPROVEMENT_LEVEL),
    hasMetropolis: z.boolean(),
    nextLevelDiscount: z.number().int().nonnegative().exactOptional()
}).strict();
const mechanicCityImprovementsTypeStatePartialSchema = createPartialStrictObjectSchemaWithAtLeastOneProperty(mechanicCityImprovementsTypeStateSchema);
const mechanicCityImprovementsPlayerStateSchema = createKeyRecordSchema(cityImprovementTypeKeys, mechanicCityImprovementsTypeStateSchema);
const playerColorNumericKeys = EnumUtils.getEnumValues(PlayerColor);
export const mechanicCityImprovementsStateSchema = createKeyRecordSchema(playerColorNumericKeys, mechanicCityImprovementsPlayerStateSchema);
export function validateMechanicCityImprovementsState(data) {
    return validateState(mechanicCityImprovementsStateSchema, data);
}
const mechanicCityImprovementsPlayerStatePartialSchema = createKeyRecordSchema(cityImprovementTypeKeys, mechanicCityImprovementsTypeStatePartialSchema, {
    requireAtLeastOneEntry: true
});
export const mechanicCityImprovementsStatePartialSchema = createKeyRecordSchema(playerColorNumericKeys, mechanicCityImprovementsPlayerStatePartialSchema, {
    requireAtLeastOneEntry: true
});
